import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { useReducedMotion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSEO } from "@/lib/useSEO";

export default function Layout({ children }) {
  const lenisRef = useRef(null);
  const { pathname, hash } = useLocation();
  const reduce = useReducedMotion();
  useSEO();

  useEffect(() => {
    if (reduce) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [reduce]);

  // Handle route change + in-page hash scrolling.
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        requestAnimationFrame(() => {
          if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -40 });
          else el.scrollIntoView({ behavior: "smooth" });
        });
        return;
      }
    }
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="grain min-h-screen bg-dh-bg text-dh-cream selection:bg-dh-gold">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
